import { Link } from 'react-router-dom';
import { genreOptions } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-movie-2-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">神马影院</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              神马影院是一个综合性影视资源资讯平台，汇聚最新电影、电视剧资源与行业资讯，帮助你轻松发现精彩内容。
            </p>
            <div className="mt-5 flex gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-youtube-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-200 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-background-400">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-200 transition-colors hover:text-accent-400">首页</Link></li>
              <li><Link to="/category/movie" className="text-background-200 transition-colors hover:text-accent-400">电影频道</Link></li>
              <li><Link to="/category/tv" className="text-background-200 transition-colors hover:text-accent-400">电视剧频道</Link></li>
              <li><Link to="/search" className="text-background-200 transition-colors hover:text-accent-400">全站搜索</Link></li>
              <li><Link to="/about" className="text-background-200 transition-colors hover:text-accent-400">关于我们</Link></li>
              <li><Link to="/contact" className="text-background-200 transition-colors hover:text-accent-400">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-background-400">热门类型</h4>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {genreOptions.slice(0, 12).map((genre) => (
                <Link
                  key={genre}
                  to={`/search?q=${encodeURIComponent(genre)}`}
                  className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  {genre}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-background-400">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/10"><i className="ri-mail-line"></i></span>
                service@shenmatv.com
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/10"><i className="ri-phone-line"></i></span>
                400-888-6666
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/10"><i className="ri-map-pin-line"></i></span>
                北京市朝阳区影视文化产业园
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 text-xs text-background-400 sm:flex-row">
          <p>© 2026 神马影院 Shenma Cinema. 本站内容均为演示示例，仅供学习与浏览。</p>
          <p className="flex items-center gap-4">
            <span className="cursor-pointer transition-colors hover:text-accent-400">用户协议</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">隐私政策</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">免责声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}